import { get, has, isEmpty, filter, isNil, omitBy, isArray, includes } from 'lodash';

const LodashPrototypes = {
  install(Vue) {
    Object.defineProperties(Vue.prototype, { _get: { get() { return get; } } });
    Object.defineProperties(Vue.prototype, { _has: { get() { return has; } } });
    Object.defineProperties(Vue.prototype, { _isEmpty: { get() { return isEmpty; } } });
    Object.defineProperties(Vue.prototype, { _isNil: { get() { return isNil; } } });
    Object.defineProperties(Vue.prototype, { _filter: { get() { return filter; } } });
    Object.defineProperties(Vue.prototype, { _omitBy: { get() { return omitBy; } } });
    Object.defineProperties(Vue.prototype, { _includes: { get() { return includes; } } });
    Object.defineProperties(Vue.prototype, { _isArray: { get() { return isArray; } } });
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.use(LodashPrototypes);
    }
  },
};

export default LodashPrototypes;



// WEBPACK FOOTER //
// ./src/init/lodash-prototypes.js